<template>
    <v-container class="mt-4 px-5" fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title primary-title class="text-subtitle-1">
              <span class="text-subtitle-1">Mi Teachers Mode — Administración de reservación de salones virtuales</span>
            </v-card-title>
            <v-card-text class="pt-0">
              <p class="text-body-2 grey--text text--darken-1 mb-0">
                Configuración de servidores (Zoom), días habilitados y bloqueos por horario de clases. INBI y Fast English son independientes.
                Las reservaciones de maestros se gestionan en otro panel.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
  
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-tabs v-model="tabEscuela" background-color="transparent" grow>
              <v-tab class="text-capitalize">
                <v-icon left small color="#44A7FF">mdi-school</v-icon>
                INBI
              </v-tab>
              <v-tab class="text-capitalize">
                <v-icon left small color="#000B58">mdi-school</v-icon>
                Fast English
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabEscuela">
              <v-tab-item>
                <v-card flat class="pa-4">
                  <TeacherEscuelaReservacion :escuela="1" />
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat class="pa-4">
                  <TeacherEscuelaReservacion :escuela="2" />
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TeacherEscuelaReservacion from '@/components/academico/teachersmode/TeacherEscuelaReservacion.vue'
  
  export default {
    components: {
      TeacherEscuelaReservacion,
    },
  
    data: () => ({
      tabEscuela: 0,
    }),
  }
  </script>
  